// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"781b9ced","522":"3c62420b"}[chunkId] + ".css";
};